import Icon from '../components/Icon.vue'

Icon.register({
  'dot-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM336 256C336 300.1 300.1 336 256 336S176 300.1 176 256 211.9 176 256 176 336 211.9 336 256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dot-circle.js
// module id = 7YaM
// module chunks = 144